var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"authentication-scan-code-modal","classes":['modal-window'],"transition":"scale","scrollable":"","click-to-close":false,"width":"800px","height":"680px"}},[_c('div',{staticClass:"modal-container"},[_c('two-factor-authentication-scan-code')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }